import { Box, styled, TextField } from '@mui/material'

export const FilterTextField = styled(TextField)({
  '& .MuiInput-root': {
    marginTop: '19px',
  },
})

export const CertificateImageContainer = styled(Box)({
  cursor: 'pointer',
  padding: 0,
  margin: 0,
})
